var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centerx popup"},[_c('vs-popup',{staticClass:"holamundo",attrs:{"icon-close":"x","title":this.title,"active":_vm.active},on:{"update:active":function($event){_vm.active=$event}}},[_c('div',{staticClass:"content",attrs:{"id":"cont"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }